/**
 * Export component file to be used on project
 */

import ResendPin from './ResendPin';
export default ResendPin;